/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ImagesBM } from 'src/components/imagesBM';
import { CommentsModal } from 'src/layouts/fieldFarmerDetails/CommentsModal';
import { HeaderAndCommentsIcon } from 'src/layouts/fieldFarmerDetails/HeaderAndCommentsIcon';
import { SelectAndInput } from 'src/layouts/fieldFarmerDetails/SelectAndInput';
import { getImagesURL } from 'src/utils/getURL';
import heic2any from 'heic2any';
import { PDFBM } from './PDFBM';

export const LandRecordPath = ({
  path,
  dis,
  header,
  keyValue,
  commentList,
  comments,
  setComments,
  isVerificationReady,
  onChange,
  landId,
  farmerId
}) => {
  const [modal, setModal] = useState(false);
  const [landImgPath, setLandImgPath] = useState([]);
  const [pdfPath, setPdfPath] = useState([]);
  const user = useSelector((store) => store.userRoot.user);
  const readonly = user?.readonly;
  useEffect(() => {
    if (path) {
      getUrl();
      getPdfUrl();
    }
  }, [path]);

  async function processImageUrls(urlArray) {
    const results = await Promise.all(
      urlArray.map(async (url) => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();

          const isHeic = blob.type === 'image/heic' || blob.type === 'image/heif';
          if (isHeic) {
            const pngBlob = await heic2any({
              blob,
              toType: 'image/png',
              quality: 1
            });
            return URL.createObjectURL(pngBlob);
          }
          return URL.createObjectURL(blob);
        } catch (err) {
          console.error('Error processing image:', url, err);
          return null; // or return a placeholder image URL
        }
      })
    );

    return results.filter(Boolean); // remove any nulls
  }

  const getUrl = async () => {
    let imgPath = [];

    if (dis) {
      imgPath = await getImagesURL(path, dis);
    } else {
      imgPath = await getImagesURL([path]);
    }    
    setLandImgPath(await processImageUrls(imgPath));
  };

  const getPdfUrl = () => {
    if (!path.includes('.pdf')) {
      return;
    }
    const pdfPath = [];
    if (dis) {
      for (const ele of path.split(dis)) {
        if (ele.includes('.pdf')) {
          pdfPath.push(ele);
        }
      }
    } else {
      pdfPath.push(path);
    }
    setPdfPath(pdfPath);
  };
  return (
    <Paper
      sx={{
        padding: '1rem',
        marginTop: '0.5rem',
        border: comments?.length ? '2px solid red' : null
      }}
      elevation={10}
    >
      <HeaderAndCommentsIcon
        isVerificationReady={isVerificationReady}
        header={header}
        modal={modal}
        setModal={setModal}
        comments={comments}
        setComments={setComments}
        commentList={commentList}
        readonly={readonly}
      />
      {keyValue ? (
        <SelectAndInput
          elevation={1}
          sx={{
            padding: '0rem',
            margin: 'auto'
          }}
          onChange={(key, value) => onChange(key, value)}
          editKeyValue={keyValue}
        />
      ) : null}
      {landId && (
        <h4>
          Land ID: <span>{landId}</span>
        </h4>
      )}

      {landImgPath.map((ele, index) => (
        <Box
          key={`${index}jd`}
          sx={{
            width: '100%',
            justifyItems: 'center'
          }}
        >
          <ImagesBM url={ele} />
        </Box>
      ))}

      {pdfPath.map((ele, index) => (
        <Box
          key={`${index}jd`}
          sx={{
            width: '100%'
          }}
        >
          <PDFBM url={ele} farmerId={farmerId} showDownload />
        </Box>
      ))}

      <CommentsModal
        modal={modal}
        setModal={setModal}
        comments={comments}
        setComments={setComments}
        commentList={commentList}
      />
    </Paper>
  );
};